    
<template>
  <common-page-layout v-if="business && business.pwa">
    <span slot="fixedtopbuttons">
      <back-button @click="$router.push('/admin/home')" />      
      <large-button  @click="saveBusiness()">Save</large-button>
    </span>

    <h4>Edit Store Positions</h4>    
    <p>
        <font color="red"><b>Here you can add Table positions to allow customers to let staff know where they are sitting. Don't add to many as it becomes hard for customers to select.</b></font>
    </p>

    <span v-if="business.positions">
      <p>
        <label class="w3-text-grey">Position Label</label>
        <input class="w3-input w3-border" placeholder="Label customers see for location" type="text" v-model="business.positions.title"/>
      </p>

      <div :key="positionindex" class="w3-cell-row" v-for="(position, positionindex) in business.positions.items">  
        <div class="w3-cell w3-container">
          <input class="w3-input w3-border" type="text" max="25" maxlength="25" v-model="position.label"/>
        </div> 
        <div class="w3-cell w3-container">
          <delete-button @click="removePosition(positionindex)"/>
        </div>
      </div>      
      
      <footer class="w3-container footer">          
          <add-button @click="addPosition()" class="w3-button w3-border w3-round-xxlarge">Position</add-button>
      </footer>  

    </span>
      
  
  
  </common-page-layout>
</template>


<script>
  import {
    mapGetters,
    mapActions,
    mapMutations
  } from "vuex";
  // var mounted=true;
  export default {
    data: function() {
      return {
        positions:null
      };
    },
    methods: {
      async addPosition() { 
        let newkey
        await this.createGuidKey().then((key)=>{
           newkey = key          
        })

        let temppos = {...this.business.positions.items}
        temppos[newkey]={}
        this.business.positions.items = temppos
        
      }, 
      async removePosition(key) { 
        console.log(key)
        let temppos = {...this.business.positions}
        delete temppos.items[key]
        this.business.positions = temppos
        
      }, 
      saveBusiness(){          
          this.businesscommands({command:'saveBusinessStandardAdmin',business:this.business})
      },
      ...mapActions(["createGuidKey","businesscommands"])
    },
    computed: {
      ...mapGetters(["business"])
    },
    created(){        
    },
    mounted: () => {
      // this.mounted = true;
    }
  };
</script>
 
<style>

  
  textarea {
    width: 100%;
    height: 150px;
    padding: 12px 20px;
    box-sizing: border-box;
    border: 2px solid #ccc;
    border-radius: 4px;
    background-color: #f8f8f8;
    resize: none;
  }
  
  .description {
    padding-bottom: 10px;
    text-align: center;
  }
  
  .groupings {
    padding-bottom: 5px;
  }
</style>



// WEBPACK FOOTER //
// src/components/admin/AdminBusinessProjects.vue